<template>
    <div class="col box-shadow pt-3">
        <div v-if="$route.path != '/listing-new'">
            <div class="row justify-content-between">
                <div class="col">
                    Available Pricing
                </div>
                <div v-if="isAdmin && $route.path == '/unit-mix'">
                  <div>AVG Size (All Units)</div>
                  <div class="sub-header">{{ Math.round(currentAvailability.all_avg_size) }}</div>
                </div>
                <div class="col row justify-content-end">
                    <div class="mx-4 text-center">
                        <div>UNITS</div>
                        <div class="sub-header">{{ currentAvailability.units }}</div>
                    </div>
                    <div class="mx-4 text-center">
                        <div>AVG Size</div>
                        <div class="sub-header">
                          {{ isAdmin && $route.path == '/unit-mix' ? `${Math.round(currentAvailability.size)}` : Math.round(currentAvailability.size) }}
                          <span v-if="isAdmin && $route.path == '/unit-mix'" :class="avgSizeMark.color"><font-awesome-icon :icon="avgSizeMark.icon" /></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row border-top py-3 bg-white">
                <div class="col border-right">
                    <div class="title-header">GROSS</div>
                    <div class="row">
                        <div class="col text-center">
                            <div class="title-sub-header">AVG Price</div>
                            <div class="value">${{ currentAvailability.list_price | numFormat}}</div>
                        </div>
                        <div class="col-6 text-center">
                            <div class="title-sub-header">AVG $PSF</div>
                            <div class="value" v-if="currentAvailability.psf == 'NaN'">$0</div>
                            <div class="value" v-else-if="isMarketStrata">${{currentAvailability.psf}}</div>
                            <div class="value" v-else>${{currentAvailability.psf}}</div>
                        </div>
                    </div>
                </div>
                <div class="col" v-if="$route.path != '/rental-report'">
                    <div class="title-header">NET</div>
                    <div class="row">
                        <div class="col-6 text-center">
                            <div class="title-sub-header">AVG Price</div>
                            <div class="value">${{ currentAvailability.net_price | numFormat }}</div>
                        </div>
                        <div class="col-6 text-center">
                            <div class="title-sub-header">AVG $PSF</div>
                            <div class="value" v-if="currentAvailability.net_psf == 'NaN'">$0</div>
                            <div class="value" v-else-if="isMarketStrata">${{currentAvailability.net_psf | numFormat}}</div>
                            <div class="value" v-else>${{currentAvailability.net_psf}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row justify-content-between">
                <div class="col">
                </div>
                <div class="col row justify-content-end">
                    <div class="mx-4 text-center">
                        <div>PROJECTS</div>
                        <div class="sub-header">{{ currentAvailability.total_projects.toLocaleString() }}</div>
                    </div>
                </div>
            </div>
            <div class="row border-top py-3 bg-white">
                <div class="col-12 col-xl-6 border-right">
                    <div class="title-header">Inventory</div>
                    <div class="row">
                        <div class="col-3 text-center">
                            <div class="title-sub-header">Total Units</div>
                            <div class="value">{{ currentAvailability.total_units.toLocaleString() }}</div>
                        </div>
                        <div class="col-3 text-center">
                            <div class="title-sub-header">Rlsd Units</div>
                            <div class="value">{{ currentAvailability.total_released_units.toLocaleString() }}</div>
                        </div>
                        <div class="col-3 text-center">
                            <div class="title-sub-header">{{ isMarketStrata ? 'Sold' : 'Leased' }} Units</div>
                            <div class="value">{{ currentAvailability.total_reported_sold | numFormat}}</div>
                        </div>
                        <div class="col-3 text-center">
                            <div class="title-sub-header">{{ isMarketStrata ? 'Sold' : 'Leased' }} %</div>
                            <div class="value">{{currentAvailability.sold_percentage | numFormat}}%</div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xl-6">
                    <div class="title-header">Net Pricing</div>
                    <div class="row">
                        <div class="col-4 text-center">
                            <div class="title-sub-header">AVG Size</div>
                            <div class="value">{{ !isNaN(currentAvailability.weighted_average_size) ? Math.round(currentAvailability.weighted_average_size).toLocaleString() : 0 }}</div>
                        </div>
                        <div class="col-4 text-center">
                            <div class="title-sub-header">AVG Price</div>
                            <div class="value">${{ currentAvailability.net_price | numFormat }}</div>
                        </div>
                        <div class="col-4 text-center">
                            <div class="title-sub-header">AVG $PSF</div>
                            <div class="value" v-if="currentAvailability.net_psf == 'NaN'">$0</div>
                            <div class="value" v-else-if="isMarketStrata">${{currentAvailability.net_psf | numFormat}}</div>
                            <div class="value" v-else>${{currentAvailability.net_psf}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- {{ currentAvailability }} -->
    </div>
</template>

<script>
    import numFormat from 'vue-filter-number-format';
    import { mapStores, mapState } from "pinia";
    import { useUserStore } from "../../store/UserStore";
    export default {
      props: {
        currentAvailability: {
          type: Object,
          required: true
        },
        isMarketStrata: {
          type: Boolean,
          default: false
        }
      },
      computed:{
        ...mapState(useUserStore, ["current_user"]),
        isAdmin: {
          get() {
            return this.current_user.role == "admin";
          },
        },
        avgSizeMark(){
          var diff = Math.round(this.currentAvailability.all_avg_size - this.currentAvailability.size)
          var mark = {
            icon:null,
            color:null,
            value:null
          }

          if(diff <= 0) {
            mark.icon = ['fas','check']
            mark.color = 'text-success'
            mark.value = diff
          } else {
            mark.icon = ['fas','times']
            mark.color = 'text-danger'
            mark.value = diff
          }
          return mark
        }
      }
    }
</script>

<style lang="scss" scoped>
    @media only screen and (max-width: 1900px) {
      .title-sub-header{
          font-size: 16px !important;
      }
    }
    .sub-header {
        font-size: larger;
        font-weight: 600;
        color: #495f74;
    }

    .title-header {
        font-weight: 500;
        color: #666;
        font-size: 26px;
    }

    .title-sub-header{
        font-size: 20px;
        color: #7e7e7e;
        font-weight: 500;
    }

    .value{
        font-size: 30px;
        font-weight: bold;
    }

    .box-shadow {
        border-radius: 5px;
        box-shadow: 0px 0px 15px 3px #ebebeb;
    }
</style>
